// shared/utils/firebase-push.js

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { fetchWithAuth } from "./authFetch";

const firebaseConfig = {
    apiKey: "AIzaSyCYXs7JeVq_q0KPTnBU2duQJJB3PQz1dsA",
    authDomain: "tanm-5b6a7.firebaseapp.com",
    projectId: "tanm-5b6a7",
    storageBucket: "tanm-5b6a7.firebasestorage.app",
    messagingSenderId: "792158975137",
    appId: "1:792158975137:web:9f0c937ddef726efe56ce0",
    measurementId: "G-M4QX4T13VQ"
};

let messaging;

export async function setupFirebasePush() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
        console.warn('[FCM] Safari not supported. Skipping push.');
        return;
    }

    if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') {
            console.warn('[FCM] Notification permission denied.');
            return;
        }
    } else if (Notification.permission === 'denied') {
        console.warn('[FCM] Notifications are denied by the user or browser.');
        return;
    }

    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);

    try {
        const token = await getToken(messaging, {
            vapidKey: 'BAAqU_rDfe0XX0enwY4hNM9YjljNB4s0g4UXg4BEh76lg4t77QaB371WCggzNlZTSkALHI9E49zi48d4K06ojlc'
        });

        if (!token) {
            console.warn('[FCM] No token received.');
            return;
        }

        const storedToken = localStorage.getItem('fcm_token');
        if (storedToken === token) {
            // Already registered
            return;
        }

        const platform = /android/i.test(navigator.userAgent)
            ? 'android'
            : /iPad|iPhone|iPod/.test(navigator.userAgent)
                ? 'ios'
                : 'web';

        await fetchWithAuth('/users/fcm-token', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token, platform })
        });

        localStorage.setItem('fcm_token', token);
        console.log('[FCM] Token registered:', token);
    } catch (err) {
        console.error('[FCM] Failed to get or send token:', err);
    }

    onMessage(messaging, (payload) => {
        console.log('[FCM] Message received:', payload);
    });
}
